export var DEFAULT_CLASS_NAME = 'dynamic-tiles-container';